import React from 'react';
import { Box, Flex, FlexColumn, Text } from 'core/components';
import KentikLogo from 'app/components/KentikLogo';

const RunbookOptionRenderer = (option) => {
  const { label, value, selectItem, className, isPreset, selected, handleOptionRef, focused, description } = option;

  const ariaProps = {};
  if (selected) {
    ariaProps['aria-selected'] = selected;
  }

  return (
    <Box
      pt="4px"
      pb="4px"
      onClick={() => selectItem(value)}
      key={value}
      className={className}
      {...ariaProps}
      tabIndex={focused && handleOptionRef ? '0' : undefined}
      ref={focused && handleOptionRef}
    >
      <Flex alignItems="center" gap="6px">
        {isPreset && <KentikLogo onlyMark alt="Kentik" style={{ minWidth: 14, maxWidth: 14 }} />}
        <FlexColumn>
          <Text>{label}</Text>
          {description && (
            <Text muted small>
              {description}
            </Text>
          )}
        </FlexColumn>
      </Flex>
    </Box>
  );
};

export default RunbookOptionRenderer;
